import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import MethodologyOverview from "@/pages/methodology/Overview";
import Why from "@/pages/methodology/Why";
import Framework from "@/pages/methodology/Framework";
import Science from "@/pages/methodology/Science";
import HowItWorks from "@/pages/methodology/HowItWorks";
import Outcomes from "@/pages/methodology/Outcomes";
import ApplicationsHub from "@/pages/applications/ApplicationsHub";
import Recovery from "@/pages/applications/Recovery";
import StressBurnout from "@/pages/applications/StressBurnout";
import AnxietyRegulation from "@/pages/applications/AnxietyRegulation";
import HabitChange from "@/pages/applications/HabitChange";
import Performance from "@/pages/applications/Performance";
import TraumaAdaptation from "@/pages/applications/TraumaAdaptation";
import Origin from "@/pages/about/Origin";
import ProgramsHub from "@/pages/programs/ProgramsHub";
import Foundations from "@/pages/programs/Foundations";
import GuidedImplementation from "@/pages/programs/GuidedImplementation";
import ProfessionalConsultation from "@/pages/programs/ProfessionalConsultation";
import OrganizationalPartnerships from "@/pages/programs/OrganizationalPartnerships";
import FoundationsHub from "@/pages/foundations/FoundationsHub";
import {
  ExercisePhysiology,
  Neuroplasticity,
  StressPhysiology,
  BehavioralScience,
  RecoveryScience,
  HumanPerformance,
} from "@/pages/foundations/Pillars";
import AssessmentEntry from "@/pages/AssessmentEntry";
import AssessmentOverview from "@/pages/AssessmentOverview";
import Coaching from "@/pages/Coaching";
import Apply from "@/pages/Apply";
import AssessmentResultsGallery from "@/pages/AssessmentResultsGallery";
import DailyApp from "@/pages/DailyApp";
import AdminDashboard from "@/pages/AdminDashboard";
import AssessmentCompanionPrompt from "@/components/assessment/AssessmentCompanionPrompt";
import CompanionRoutineSettings from "@/components/daily/CompanionRoutineSettings";
import CloudAccountGate from "@/components/account/CloudAccountGate";
import CompanionConversationBridge from "@/components/account/CompanionConversationBridge";
import SeoRoute from "@/seo/SeoRoute";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const AccountProtected = ({ children }) => (
  <CloudAccountGate>{children}</CloudAccountGate>
);

const CloudProtected = ({ children }) => (
  <CloudAccountGate>
    <CompanionConversationBridge />
    {children}
  </CloudAccountGate>
);

function App() {
  return (
    <div data-testid="app-root" className="min-h-screen forr-canvas forr-text-ink">
      <BrowserRouter>
        <SeoRoute />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/methodology" element={<MethodologyOverview />} />
          <Route path="/methodology/why" element={<Why />} />
          <Route path="/methodology/framework" element={<Framework />} />
          <Route path="/methodology/science" element={<Science />} />
          <Route path="/methodology/how-it-works" element={<HowItWorks />} />
          <Route path="/methodology/outcomes" element={<Outcomes />} />
          <Route path="/applications" element={<ApplicationsHub />} />
          <Route path="/applications/recovery" element={<Recovery />} />
          <Route path="/applications/stress-burnout" element={<StressBurnout />} />
          <Route path="/applications/anxiety-regulation" element={<AnxietyRegulation />} />
          <Route path="/applications/habit-change" element={<HabitChange />} />
          <Route path="/applications/performance" element={<Performance />} />
          <Route path="/applications/trauma-adaptation" element={<TraumaAdaptation />} />
          <Route path="/about/origin" element={<Origin />} />
          <Route path="/programs" element={<ProgramsHub />} />
          <Route path="/programs/foundations" element={<Foundations />} />
          <Route path="/programs/guided-implementation" element={<GuidedImplementation />} />
          <Route path="/programs/professional-consultation" element={<ProfessionalConsultation />} />
          <Route path="/programs/organizational-partnerships" element={<OrganizationalPartnerships />} />
          <Route path="/foundations" element={<FoundationsHub />} />
          <Route path="/foundations/exercise-physiology" element={<ExercisePhysiology />} />
          <Route path="/foundations/neuroplasticity" element={<Neuroplasticity />} />
          <Route path="/foundations/stress-physiology" element={<StressPhysiology />} />
          <Route path="/foundations/behavioral-science" element={<BehavioralScience />} />
          <Route path="/foundations/recovery-science" element={<RecoveryScience />} />
          <Route path="/foundations/human-performance" element={<HumanPerformance />} />
          <Route path="/assessment" element={<AssessmentOverview />} />
          <Route
            path="/assessment/start"
            element={
              <CloudProtected>
                <AssessmentEntry />
              </CloudProtected>
            }
          />
          <Route path="/coaching" element={<Coaching />} />
          <Route
            path="/app/*"
            element={
              <CloudProtected>
                <DailyApp />
              </CloudProtected>
            }
          />
          <Route
            path="/admin/*"
            element={
              <AccountProtected>
                <AdminDashboard />
              </AccountProtected>
            }
          />
          {process.env.NODE_ENV !== "production" && (
            <Route path="/assessment/review-gallery" element={<AssessmentResultsGallery />} />
          )}
          <Route path="/apply" element={<Apply />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <AssessmentCompanionPrompt />
        <CompanionRoutineSettings />
      </BrowserRouter>
    </div>
  );
}

export default App;
